import React, { useState } from 'react';
import './Users.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';

const Users = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
  };

return( 
<div>
  <SideMenuBar></SideMenuBar>  

<div class="content">
  <NewHeader></NewHeader>

  <div className='row2'>
    <h3 className='users'>Users</h3>  
  </div>

  <div className='row3'>
    <div className='searchBox'>
      <div class="column1_searchBox">
        <img className='search' src="../assets/search.png" alt="search" height={"18px"}></img>
      </div>
  
      <div class="column2_searchBox">
        <input className='search_input1' placeholder='Search'></input>
      </div>
    </div>
    <button className='add_user_btn' onClick={openForm}>Add User &nbsp;<img className='plus' src="../assets/plus.png" alt="plus" height={"8px"}></img></button>   
  </div>
  {isFormOpen && (
        <>
          <div className="overlay_Users" onClick={closeForm}></div>
          <div className="popup-form_Users">
            <span className="close_Users" onClick={closeForm}>&times;</span>
            <p><b>Add User</b></p>
            {/* Your form content goes here */}
            <form>
              {/* Form fields go here */}
            
              <div class="popup_row_Users">
                <div class="popup_column1_Users">
                  <h3>Personal Info</h3>
                  <p>First Name</p>
                    <input className='popup_input_Users' placeholder='Enter First Name*'></input>

                  <p>Last Name</p>
                    <input className='popup_input_Users' placeholder='Enter Last Name*'></input>                    

                  <p>Email ID</p>
                    <input className='popup_input_Users' placeholder='Enter Email ID*'></input>

                  <p>Phone No.</p>
                    <input className='popup_input_Users' placeholder='Enter Phone No.*'></input>

                  <p>Blood Group</p>
                    <input className='popup_input_Users' placeholder='Enter Blood Group*'></input>

                  <p>Address</p>
                    <textarea className='address_input_Users' placeholder='Enter Address*'></textarea>
                    
                </div>
                
                <div class="popup_column2_Users">
                  <h3>Work Info</h3>
                  <p>User ID</p>
                    <input className='popup_input_Users' placeholder='Enter User ID*'></input>

                  <p>Password</p>
                    <input className='popup_input_Users' placeholder='Enter Password*'></input><br/><br/>
                    <input className='popup_input_Users' placeholder='Confirm Password*'></input>

                  <p>Role</p>
                    <input className='popup_input_Users' placeholder='Enter Role*'></input>

                  <p>Identity Proof</p>
                    <img src='../assets/cloud_upload.png' alt='cloud_upload-icon' height={25}></img>&nbsp;<i className='uploadHere_Users'>Upload Here</i><br/>

                  <button type="submit" value="Submit" className='popup_form_addTask_CardView'>Add User</button>
                  <button type="submit" value="close" onClick={closeForm} className='popup_form_cancel_CardView'>Cancel</button>
                </div>
              </div>

              
            
            </form>
          </div>
 
        </>
      )}
    

  <div className='row4_Users'>
    <div className='sub_row4_heading_Users'>
        <p className='name_Users'>Name</p>
        <p className='role_Users'>Role</p>
        <p className='inTime_Users'>In_Time</p>
        <p className='total_tasks_Users'>Total_Tasks</p>
        <p className='current_location_Users'>Current_Location</p>
        <p className='action_Users'>Action</p>
    </div>

    <div className='sub_row4_Users'>
        <p className='name_Users'>Name</p>
        <p className='role_Users'>Role</p>
        <p className='inTime_Users'>In_Time</p>
        <p className='total_tasks_Users'>Total_Tasks</p>
        <p className='current_location_Users'>Current_Location</p>
        <div className='pencil_trash'>
            <a href='/'><img src="../assets/pencil.png" className='pencil_Users' alt="pencil" height={"20px"}></img></a>&nbsp;&nbsp;&nbsp;&nbsp;
            <a href='/'><img src="../assets/trash.png" className='trash_Users' alt="trash" height={"19px"}></img></a>
        </div>
    </div>
  </div>

  </div>

</div>
 )
}

export default Users;